export enum ETemplateType {
  Warehouse = 0,
  Company = 5
}
